import React from 'react';
import { Field, FieldArray, change } from 'redux-form';
import { InputWithIcon, AutoCompleteSelect } from '../../../../../../itrust_common/components/form';
import { useCurrentTypeHook } from '../../../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook';
import DiscountField from '../../DiscountField';
import { connect } from 'react-redux';
import LensType from './LensType';

let Lens = props => {
  const { member, currentEyeglass, pprops, orderStoreId, currentStoreOtherDetails } = props;
  const currency = useCurrentTypeHook();

  const getStoreIdForSearch = () => {
    let StoreId = localStorage.getItem('StoreID')
    if (!StoreId && StoreId == null) {
      return orderStoreId
    }
    return StoreId
  }

  return (
    <div className="row mx-0 bg-light">
      <div className="col-12 p-5">
        <h6>Lens</h6>
      </div>
      {!currentStoreOtherDetails?.stock_lens && <FieldArray
        name={`${member}.lens_types_attributes`}
        props={{
          pprops: pprops,
          currentEyeglass: currentEyeglass,
          member: member,
        }}
        component={LensType}
      />}
      <Field
        name={`${member}[lens_material_id]`}
        displayName={`${member}[lens_material_name]`}
        component={AutoCompleteSelect}
        onChangeHook={(data) => { pprops.dispatch(change('orderEyeglassForm', `${member}[lens_material_id]`, data.id)); setTimeout(() => pprops.submit(), 500) }}
        klass="Settings::EyeglassLensMaterial"
        additionalFilters={{ store_inventory: getStoreIdForSearch() }}
        textField="material"
        valueField="id"
        placeholder="Placeholder"
        wrapperClasses="col-4 form-group"
        className="form-control"
        label="Material"
        labelClasses="w-100"
      />
      <Field name={`${member}[lens_material_unit_price]`} type="number" component={InputWithIcon} title={currency.symbol} label="Unit Price" labelClasses="w-100" className="form-control" wrapperClasses="col-2 px-2 form-group" onBlur={() => setTimeout(() => pprops.submit(), 500)}
       />
      <Field name={`${member}[lens_material_copay]`} component={InputWithIcon} title={currency.symbol} label="Copay" labelClasses="w-100" className="form-control" wrapperClasses="col-2 px-3 form-group" onBlur={() => setTimeout(() => pprops.submit(), 500)} />
      <div className="col-3">
        <label>Discount</label>
        <DiscountField
          cashName={`${member}[lens_material_cash_discount]`}
          percentageName={`${member}[lens_material_percentage_discount]`}
          discountTypeName={`${member}[lens_material_discount_type]`}
          defaultType={currentEyeglass.lens_material_discount_type}
          prependClasses="py-2"
          onBlur={() => setTimeout(() => pprops.submit(), 500)}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { order: { order }, currentStore } = state
  return {
    orderStoreId: order.store_id,
    currentStoreOtherDetails: currentStore.store?.other_details
  }
}

export default connect(mapStateToProps)(Lens);